




























































































































































































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums
import { SortableItems } from "@/data/enums/sortableItems";

// Types
import { ISortableCategory, ISortableCan } from "@/models/reordering";
import { IProductCategory } from "@/models/products";

@Component
export default class SortableItem extends Vue {
  // Props
  @Prop({ required: true })
  public sortableElement!: ISortableCategory;

  @Prop({ required: true })
  public scope!: string;

  @Prop({ required: true })
  public can!: ISortableCan;

  @Prop({ required: true })
  public itemName!: string;

  @Prop({ default: false })
  public isCategorySelectable!: boolean;

  @Prop({ default: true })
  public showCategoryItems!: boolean;

  @Prop({ default: true })
  public showCounters!: boolean;

  @Prop({ default: true })
  public multipleSelect!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: "" })
  public routeName!: string;

  // Variables
  public sortableCategoriesModule = "sortableCategories";

  public get sortableItems() {
    return SortableItems;
  }

  public openCloseCategory() {
    if (!this.showCategoryItems && !this.sortableElement.items.length) return;

    this.$store.commit(`${this.sortableCategoriesModule}/updateCategory`, {
      scope: this.scope,
      categoryId: this.sortableElement.id,
      data: this.$_.merge(
        {
          isOpened: !this.sortableElement.isOpened
        },
        this.sortableElement.offset === 0 && !this.sortableElement.isFullyLoaded
          ? { isInitialising: true }
          : {}
      )
    });
  }

  public get isSelectable() {
    return this.can.select && (this.isItem || this.isCategorySelectable);
  }

  public get isClickable() {
    return this.can.click && (!this.isSelectable || this.isCategory);
  }

  public get isManagable() {
    return (
      (this.can.createSubcategory ||
        this.can.createItem ||
        this.can.view ||
        this.can.delete) &&
      !this.can.detach &&
      !this.isDisabled
    );
  }

  public get isLink() {
    return (
      this.isItem &&
      !this.isSelectable &&
      this.can.click &&
      !this.sortableElement.isDisabled
    );
  }

  public get itemRoute() {
    if (!this.isLink) return {};

    return {
      name: this.routeName,
      params: {
        productId: this.sortableElement.itemId
      }
    };
  }

  public async itemClicked() {
    if (
      !(this.isDisabled && this.isCategory) &&
      (!this.can.click || this.sortableElement.isDisabled)
    )
      return;

    if (
      this.isCategory &&
      (this.showCategoryItems || this.sortableElement.items.length)
    ) {
      this.openCloseCategory();
      return;
    }

    if (this.isSelectable) {
      this.itemSelected();
    } else {
      this.$emit("view", this.sortableElement);
    }
  }

  public async itemSelected() {
    if (this.sortableElement.isDisabled) {
      return;
    }

    const newSelected = !this.sortableElement.isSelected;

    await this.$store.commit(
      `${this.sortableCategoriesModule}/${
        this.isCategory ? "updateCategory" : "updateItem"
      }`,
      this.$_.merge(
        {
          scope: this.scope,
          categoryId: this.isCategory
            ? this.sortableElement.id
            : this.sortableElement.category_id,
          data: { isSelected: newSelected }
        },
        this.isCategory ? {} : { itemId: this.sortableElement.id }
      )
    );

    this.$emit("selectElement", this.sortableElement, newSelected);
  }

  public get isCategory() {
    return this.sortableElement.type === SortableItems.CATEGORY;
  }

  public get isItem() {
    return this.sortableElement.type === SortableItems.ITEM;
  }

  public get hasLabels() {
    return this.$_.get(this.sortableElement, "labels", []).length;
  }

  public scrollTo(categoryId: IProductCategory["id"]) {
    this.$scrollTo("#category_" + categoryId, {
      container: "#multilevelSortableList"
    });
  }

  public createSubcategory() {
    this.$emit("createSubcategory", this.sortableElement.id);
  }

  public createItem() {
    this.$emit("createItem", this.sortableElement.id);
  }

  public view() {
    if (this.can.view) {
      this.$emit("view", this.sortableElement);
    }
  }

  public duplicateItem() {
    if (this.can.duplicateItem) {
      this.$emit("duplicateItem", this.sortableElement);
    }
  }

  public deleteElement() {
    this.$emit(
      "deleteElement",
      this.sortableElement.id,
      this.sortableElement.type,
      this.isItem ? this.sortableElement.itemId : null
    );
  }

  public getItemsCounter() {
    return this.$tc(
      this.sortableElement.itemsTotalMsg,
      this.sortableElement.itemsTotal
    );
  }

  public detachElement() {
    this.$emit(
      "detachElement",
      this.sortableElement.id,
      this.sortableElement.type
    );
  }
}
